import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-page404',
  templateUrl: './page404.component.html',
  styleUrls: ['./page404.component.sass']
})
export class Page404Component implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }
  goBack() {
    this.router.navigate([environment.routes.subscription]);
  }
}
